import { api } from '../index';
import { objectToFormData, objectToUrlParam } from '@/api/util';

const prefix = '/api/basic_info/notices/';

export function apiSelectNotices(params) {
	return api.get(prefix + 'list' + objectToUrlParam(params));
}

export function apiSelectNotice(notice_no) {
	return api.get(prefix + notice_no);
}

export function apiInsertNotice(notice) {
	const data = objectToFormData(notice);
	return api.post(prefix, data);
}

export function apiDeleteNotice(notice_no) {
	return api.delete(prefix + notice_no);
}
